// src/components/SaoLuu.js
import React, { useState } from "react";
import { luuTepQuanGia, addData } from "../services/api";
import { veDungLuong } from "../utils/thuNhoAnh";

// ============================================================
// 💾 SAO LƯU (Đợt N5, 14/09/2026 — mockup màn ④)
// ------------------------------------------------------------
// Anh chốt (câu 6): VPS tự sao lưu database mỗi đêm lúc 2:00, giữ 14 bản;
// anh bấm tải bản mới nhất về máy mình (hoặc Google Drive) để có một bản NẰM
// NGOÀI VPS — VPS hỏng hẳn thì dữ liệu vẫn còn ở nhà.
//
// Bản sao lưu CHỈ GỒM DATABASE, vài chục KB (anh đồng ý). Ảnh tải theo tháng
// ở Kho ảnh bên trên.
// ============================================================
function SaoLuu({ tt, onDoi, noiBao }) {
  const [dangTai, setDangTai] = useState(false);

  // Chỉ ghi "đã cất ra ngoài VPS" khi tệp ĐÃ LƯU XONG trên máy (xem api.js).
  // Anh chốt chỗ cất: D:\SaoLuu\QuanGia\CoSoDuLieu.
  const tai = async () => {
    setDangTai(true);
    try {
      const kq = await luuTepQuanGia({
        endpoint: "quan-tri/sao-luu/tai",
        tenGoiY: (tt && tt.moi_nhat && tt.moi_nhat.ten) || "quan_gia.backup",
        idCho: "quan-gia-sao-luu",
        moTa: "Bản sao lưu Quản gia (.backup)",
        duoi: ".backup",
      });
      if (kq.ketQua !== "da-luu") {
        noiBao("Chưa lưu bản sao lưu — lời nhắc vẫn giữ nguyên");
        return;
      }
      await addData("quan-tri/sao-luu/da-cat", { ten: kq.tenTep });
      noiBao(`✅ Đã cất "${kq.tenTep}" ra ngoài VPS`);
      onDoi();
    } catch (err) {
      noiBao(`⚠️ Chưa tải được bản sao lưu${err.chiTiet ? ` — ${err.chiTiet}` : ""}`);
    } finally {
      setDangTai(false);
    }
  };

  if (!tt) return null;
  if (tt === "loi") {
    return (
      <div className="card" id="sao-luu">
        <h3>💾 Sao lưu</h3>
        <div className="sao-luu-khung sao-luu-hong">
          ⚠️ Không đọc được tình trạng sao lưu. Bấm F5 thử lại; vẫn vậy thì chụp màn hình gửi Claude.
        </div>
      </div>
    );
  }
  const hong = Boolean(tt.loi) || !tt.moi_nhat || tt.moi_nhat.tuoi_gio > 26;

  return (
    <div className="card" id="sao-luu">
      <h3>💾 Sao lưu</h3>
      <div className={hong ? "sao-luu-khung sao-luu-hong" : "sao-luu-khung"}>
        {hong ? "⚠️ " : "✅ "}Tự sao lưu database <strong>mỗi đêm lúc 2:00</strong>
        <br />
        {tt.moi_nhat ? (
          <>
            Bản mới nhất: <strong>{tt.moi_nhat.luc_hien}</strong> · {veDungLuong(tt.moi_nhat.so_byte)} ·
            đang giữ <strong>{tt.so_ban}</strong>/{tt.giu_toi_da} bản
          </>
        ) : (
          <strong>Chưa có bản sao lưu nào.</strong>
        )}
        {tt.loi && (
          <div className="sao-luu-loi">
            Lần chạy gần nhất báo lỗi: <code>{tt.loi}</code> — chụp màn hình gửi Claude.
          </div>
        )}
        <br />
        Lần anh cất bản sao lưu ra ngoài VPS:{" "}
        <strong className={!tt.lan_cat || tt.lan_cat.so_ngay > 7 ? "kho-anh-cu" : ""}>
          {tt.lan_cat
            ? tt.lan_cat.so_ngay === 0
              ? `hôm nay (${tt.lan_cat.luc_hien})`
              : `${tt.lan_cat.so_ngay} ngày trước`
            : "chưa lần nào"}
        </strong>
      </div>
      <button className="sao-luu-nut-tai" onClick={tai} disabled={dangTai || !tt.moi_nhat}>
        {dangTai ? "Đang tải…" : "⬇️ Tải bản sao lưu mới nhất"}
      </button>
    </div>
  );
}

export default SaoLuu;
